import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsPhoneNumberScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.PhoneNumber />
    </View>
  );
};

export default PreProposalsPhoneNumberScreen;
